export const PRIVATE_APP_TOKEN = 'private_app_token';

export const CRM_TOKEN = 'crm_token';

export const AGENCY_ID = 'agency_id';

export const AGENCY_NAME = 'agency_name';

export const AUTH_ENABLED = 'auth_enabled';

export const LOGIN_REQUIRED = 'login_required';

export const SUBMISSION_REQUEST_DATA = 'submission_request_data';

export const SUBMISSION_DRAFT_KEY = 'submission_draft_data';

export const SUBMIT_ANONYMOUSLY = 'submit_anonymously';

/** Session-scoped category name from a create-page link, kept across the Auth0 round trip. */
export const AUTH_CATEGORY_QUERY = 'auth_category_query';

export const ELEVIO_PORTAL_URL = 'logout_redirect_url';

export const PORTAL_RETURN_URL = 'portal_return_url';

/** Set when portal_return_url arrives; cleared after handoff or stale visit. */
export const PORTAL_HANDOFF_PENDING = 'portal_handoff_pending';

export const PORTAL_HANDOFF_IN_PROGRESS = 'portal_handoff_in_progress';

/** Epoch ms when the portal login started, used to expire stale handoff markers. */
export const PORTAL_HANDOFF_STARTED_AT = 'portal_handoff_started_at';

export const PORTAL_HANDOFF_ATTEMPTS = 'portal_handoff_attempts';

export const CRM_ISSUE_ID = 'crmIssueId';

export const PENDING_FOLLOW_ISSUE_ID = 'pending_follow_issue_id';
export const PENDING_FOLLOW_ISSUE_IDS = 'pending_follow_issue_ids';

/** Rolling last-activity timestamp for citizen portal Mixpanel sessions. */
export const CITIZEN_PORTAL_SESSION_LAST_ACTIVITY_KEY = 'citizen_portal_session_last_activity';

/** Idle timeout matching Mixpanel's default session definition. */
export const CITIZEN_PORTAL_SESSION_TIMEOUT_MS = 30 * 60 * 1000;

export const PRIVATE_SUBMISSION_LISTING_TAB_QUERY_KEY = 'tab';
export const PRIVATE_SUBMISSION_LISTING_TAB_FOLLOWING_VALUE = 'following';

export const PrivateSubmissionAppRoutes = {
  ERROR: '/private-submission/error',
  NAVIGATION_ERROR: '/private-submission/navigation-error',
  MISSING_TOKEN_ERROR: '/private-submission/missing-token-error',
  LISTING: '/private-submission/listing',
  CREATE: '/private-submission/create',
  PROFILE: '/private-submission/profile',
  ISSUE: '/private-submission/issue/:crmIssueId',
  ISSUE_BASE_PATH: '/private-submission/issue',
  PUBLIC_MAP: '/private-submission/public-map',
  LOGOUT_HANDLER: '/private-submission/logout-handler',
  ONBOARDING: '/private-submission/onboarding',
};
